export const PRODUCT_TYPE_EVO = 1;
export const PRODUCT_TYPE_NOVA = 2;
